import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../api/api";
import { setLoading } from "../../loading/loadingSlice";

// GET ALL NURSES
export const getAllNurse = createAsyncThunk("getAllNurse", async ({ page, limit, search }, { dispatch, rejectWithValue }) => {
  try {
    dispatch(setLoading(true));
    const params = {
      page,
      limit,
      search,
      searchFields: "itemName,code",
    };
    const response = await api.get(`/api/v1/cc/nursing_care/nurse`, {
      params,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching nurse list:", error);
    return rejectWithValue(error.response?.data?.message || "Error fetching nurse list");
  } finally {
    dispatch(setLoading(false));
  }
});

export const getNurseDetails = createAsyncThunk("getNurseDetails", async (nurseId, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    const response = await api.get(`/api/v1/cc/nursing_care/nurse/${nurseId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching nurse details:", error);
    const errorMessage = error.response && error.response.data ? error.response.data.message : "Error fetching nurse details";
    throw new Error(errorMessage);
  } finally {
    dispatch(setLoading(false));
  }
});

// POST A NEW NURSE
export const postNurse = createAsyncThunk("postNurse", async (nurseData, { dispatch, rejectWithValue }) => {
  try {
    dispatch(setLoading(true));
    const response = await api.post(`/api/v1/cc/nursing_care/nurse`, nurseData);
    return response.data;
  } catch (error) {
    console.error("Error posting nurse data:", error);
    return rejectWithValue(error.response?.data?.message || "Error posting nurse data");
  } finally {
    dispatch(setLoading(false));
  }
});

// Edit Nurse
export const editNurse = createAsyncThunk("editNurse", async ({ nurseId, nurseData }, { dispatch, rejectWithValue }) => {
  try {
    dispatch(setLoading(true));
    const response = await api.patch(`/api/v1/cc/nursing_care/nurse/${nurseId}`, nurseData);
    return response.data;
  } catch (error) {
    console.error("Error editing nurse data:", error);
    return rejectWithValue(error.response?.data?.message || "Error editing nurse data");
  } finally {
    dispatch(setLoading(false));
  }
});

// GET ALL SERVICES
export const getAllServices = createAsyncThunk("getAllServices", async (_, { dispatch, rejectWithValue }) => {
  try {
    dispatch(setLoading(true));
    const response = await api.get(`/api/v1/cc/nursing_care/service`);
    return response.data;
  } catch (error) {
    console.error("Error fetching services:", error);
    return rejectWithValue(error.response?.data?.message || "Error fetching services");
  } finally {
    dispatch(setLoading(false));
  }
});

// GET SUB-SERVICES BY SERVICE ID
export const getSubServices = createAsyncThunk("getSubServices", async (serviceId, { dispatch, rejectWithValue }) => {
  try {
    dispatch(setLoading(true));
    const response = await api.get(`/api/v1/cc/nursing_care/service/sub_service?service=${serviceId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching sub-services:", error);
    return rejectWithValue(error.response?.data?.message || "Error fetching sub-services");
  } finally {
    dispatch(setLoading(false));
  }
});

// GET SERVICE ITEMS BY SERVICE ID & SUB-SERVICE ID
export const getServiceItems = createAsyncThunk("getServiceItems", async ({ serviceId, subServiceId }, { dispatch, rejectWithValue }) => {
  try {
    dispatch(setLoading(true));
    const response = await api.get(`/api/v1/cc/nursing_care/service/service_item?service=${serviceId}&subService=${subServiceId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching service items:", error);
    return rejectWithValue(error.response?.data?.message || "Error fetching service items");
  } finally {
    dispatch(setLoading(false));
  }
});

export const deleteNurse = createAsyncThunk("deleteNurse", async (nurseId, { dispatch, rejectWithValue }) => {
  try {
    dispatch(setLoading(true));
    await api.delete(`/api/v1/cc/nursing_care/nurse/${nurseId}`);
    return nurseId;
  } catch (error) {
    console.error("Error deleting nurse:", error);
    return rejectWithValue(error.response?.data?.message || "Error deleting nurse");
  } finally {
    dispatch(setLoading(false));
  }
});
